import React, {PropTypes} from 'react';
import IsReadIcon from 'material-ui/svg-icons/navigation/check';

const IsReadTitle = ({title, read}) => {
  const style = {
    title: {
      marginRight: "20px"
    },
    icon: {
      color: "green",
      position: "absolute",
      top: "14px",
      right: "50px",
      height: "18px"
    }
  };
  return (
    <div>
      {!read&&<div style={style.title}>{title}</div>}
      {read&&<div style={style.title}>{title} <IsReadIcon style={style.icon}/></div>}
    </div>
  );
};

IsReadTitle.propTypes = {
  title: PropTypes.string,
  read: PropTypes.bool
};

export default IsReadTitle;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/IsReadTitle.js
 **/